import { useChat } from "../../providers/chat-provider";
import { AdvisorAvatar } from "../messages/message/advisor-avatar";
import { HeaderActions } from "./actions";
import { HeaderAvatar } from "./avatar";
import { HeaderFullLogo } from "./full-logo";
import { HeaderTitles } from "./titles";

export const Header = ({
  dialogPortalContainer,
  forceOpenSettings,
}: {
  dialogPortalContainer?: HTMLElement | null;
  forceOpenSettings?: boolean;
}) => {
  const { isLiveChatActive, chatbotParams } = useChat();
  // The advisor's avatar takes the logo's place during a live chat, and the titles come back.
  const showFullLogo =
    !isLiveChatActive &&
    chatbotParams.logoType === "full" &&
    Boolean(chatbotParams.fullLogoDataUri);

  return (
    <header
      id="header"
      className="h-(--header-height) bg-(--header-background) text-(--header-foreground) shrink-0 flex flex-col justify-center"
    >
      <div
        id="header-content"
        className="flex items-center justify-between gap-(--header-gap) max-w-(--header-max-width) px-(--header-padding-x) w-full mx-auto"
      >
        <div
          id="header-titles-container"
          className="flex items-center gap-(--header-gap) overflow-hidden"
        >
          {isLiveChatActive ? (
            <AdvisorAvatar isHeader />
          ) : showFullLogo ? (
            <HeaderFullLogo />
          ) : (
            <HeaderAvatar />
          )}
          <HeaderTitles srOnly={showFullLogo} />
        </div>

        <HeaderActions
          forceOpenSettings={forceOpenSettings}
          dialogPortalContainer={dialogPortalContainer}
        />
      </div>
    </header>
  );
};
